var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-list",
        [
          _vm._l(_vm.menus, function(item, index) {
            return [
              _c(
                "v-list-tile",
                {
                  key: index,
                  attrs: {
                    ripple: "",
                    to: item.path,
                    exact: "",
                    "active-class": "turquoise primaryDark--text"
                  }
                },
                [
                  _c(
                    "v-list-tile-content",
                    {
                      class: [
                        _vm.$route.path === item.path
                          ? "body-2 font-weight-bold"
                          : "body-1"
                      ]
                    },
                    [
                      _c("v-list-tile-title", [
                        _vm._v(
                          _vm._s(item.text) + " " + _vm._s(_vm.getTotal(item))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider")
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-562227e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-562227e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/service-book/components/sidebarDetails/template.html
// module id = null
// module chunks = 